module.exports = __webpack_public_path__ + "img/ultra-diamond.15460cd3.png";